import React from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ReactGA from "react-ga4";

import {
	TrainingMaterialsViewMobile
} from '../../components/training/';

class TrainingMaterialsMobile extends React.Component {

	constructor(props) {
    super(props);

		this.state = {
      authToken: ""
	  };

  }

	componentDidMount() {
		ReactGA.pageview(window.location.pathname);

		const query = new URLSearchParams(this.props.location.search);
    const token = query.get('token')
    console.log("token: "+token)//123

    if (token) {
      if (token.length>0) {
        console.log("authToken: "+token)
        this.setState({authToken:token});
      }
    }
	}

	render() {
		return (
			<div>
				<Row>
					<Col md="12">
            <TrainingMaterialsViewMobile authToken={this.state.authToken} />
					</Col>
				</Row>
			</div>
		);
	}
}

export default TrainingMaterialsMobile;
